import "../pages.scss"
import { LocalidadesState } from '../../context/localidades/LocalidadesState';
import Datatable from "./localidadesTable/Datatable"

const LocalidadesPage = () => {
  return (
    <>
      <LocalidadesState>
        <Datatable />
      </LocalidadesState>

    </>
  )
}

export default LocalidadesPage